import React from 'react';
import { motion } from 'framer-motion';
interface FinalCTASectionProps {
  checkoutUrl: string;
}
export const FinalCTASection = ({
  checkoutUrl
}: FinalCTASectionProps) => {
  return <section className="w-full py-12 sm:py-16 px-4 bg-gradient-to-br from-[#7A3EFF] to-[#6B2FE3] relative overflow-hidden" data-id="element-151">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
    }} data-id="element-152" />
      <div className="container mx-auto max-w-4xl text-center relative z-10" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-154">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 leading-tight" data-id="element-155">
            No Pierdas Esta Oportunidad
          </h2>
          <p className="text-lg sm:text-xl text-white/90 mb-6 font-light" data-id="element-156">
            Última mentoría del año. Cupos limitados.
          </p>
          <div className="flex justify-center mb-6" data-id="element-157">
            <motion.a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="inline-block px-10 sm:px-14 py-4 bg-white text-[#7B2BFD] text-lg sm:text-xl font-bold rounded-full transition-all duration-300" style={{
            border: '3px solid #7B2BFD',
            boxShadow: '0 0 20px rgba(123, 43, 253, 0.4), 0 0 40px rgba(123, 43, 253, 0.2)'
          }} animate={{
            scale: [1, 1.05, 1]
          }} transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} whileHover={{
            scale: 1.08,
            boxShadow: '0 0 30px rgba(123, 43, 253, 0.6), 0 0 60px rgba(123, 43, 253, 0.4)'
          }} whileTap={{
            scale: 0.95
          }} data-id="element-158">
              RESERVAR MI CUPO
            </motion.a>
          </div>
          <p className="text-xs sm:text-sm text-white/70 max-w-2xl mx-auto leading-relaxed" data-id="element-159">
            Evento 100% educativo. No garantizamos resultados específicos. El
            uso de la información es responsabilidad del participante.
          </p>
        </motion.div>
      </div>
    </section>;
};